import { GRADIENTS } from './constants'
export function getGradient(
  type: keyof typeof GRADIENTS,
  variant: string,
  theme: string,
): string {
  if (type === 'primary' || type === 'accent') {
    return theme === 'neon' ? GRADIENTS[type].neon : GRADIENTS[type].default
  }
  return GRADIENTS[type][variant as keyof typeof GRADIENTS.background] || ''
}
export function getShadowClass(theme: string): string {
  return theme === 'neon' ? 'shadow-cyan-500/30' : 'shadow-purple-500/30'
}
export const getAccentColor = (theme: string) => {
  if (theme === 'neon') return 'text-teal-400'
  if (theme === 'light') return 'text-indigo-600'
  return 'text-violet-400'
}
// More sophisticated, unique color palettes
export const getGradientClasses = (theme: string) => {
  if (theme === 'neon') {
    return {
      primary: 'from-emerald-400 via-teal-500 to-cyan-600',
      accent: 'from-emerald-500 to-teal-600',
      shadow: 'shadow-teal-500/25',
      border: 'border-teal-500/20',
    }
  }
  if (theme === 'light') {
    return {
      primary: 'from-blue-500 via-indigo-600 to-violet-600',
      accent: 'from-blue-500 to-indigo-600',
      shadow: 'shadow-indigo-500/20',
      border: 'border-indigo-200',
    }
  }
  // Dark theme - more refined, sophisticated palette
  return {
    primary: 'from-fuchsia-500 via-violet-600 to-indigo-600',
    accent: 'from-fuchsia-500 to-violet-600',
    shadow: 'shadow-violet-600/25',
    border: 'border-violet-500/20',
  }
}
